
import { FaCalendarAlt, FaChalkboardTeacher } from 'react-icons/fa';
import { FaHandshake, FaDollarSign, FaUsers, FaBriefcase, FaHeart, FaTrophy, FaWallet, FaLightbulb } from "react-icons/fa6";

import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Innovative Team",
    heading: "Help Us Shape the Future of AI and Technology",
    description: "At CoreAI, we are building next-generation AI solutions that transform industries and improve lives. We're seeking forward-thinking and passionate individuals to join our mission of creating intelligent technologies that redefine the future. Be part of our team and help us revolutionize the way the world interacts with AI.",
    points: [
        {
            icon: <FaHandshake />,
            text: "Innovative Projects",
        },
        {
            icon: <FaDollarSign />,
            text: "Competitive Compensation",
        },
        {
            icon: <FaUsers />,
            text: "Collaborative Environment",
        },
        {
            icon: <FaBriefcase />,
            text: "Career Advancement",
        },
        {
            icon: <FaHeart />,
            text: "Impactful Work",
        },
    ],
};


const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Machine Learning Engineer',
        content: 'Develop and optimize machine learning models to build scalable and high-performance AI systems.',
        details: {
            location: 'InnovateAI Labs, Tech City',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in Machine Learning',
            position: '2 Positions Available',
            days: 'Monday to Friday',
            salary: '$90K - $120K',
            deadline: 'Apply Now - Open Until Filled',
            number: '987-654-3210',
        },
        overviews: [
            'Join InnovateAI Labs as a Machine Learning Engineer! You will play a critical role in developing AI-powered solutions, training machine learning models, and deploying scalable AI services. This is a unique opportunity to work with cutting-edge technologies in a collaborative and innovative environment.',
        ],
        responsibilities: [
            'Design, build, and deploy machine learning models for various AI applications.',
            'Collaborate with data scientists and software engineers to implement algorithms into production systems.',
            'Analyze large datasets to extract meaningful insights and improve model performance.',
            'Optimize ML models for scalability, performance, and reliability.',
            'Stay current with the latest AI research and integrate best practices into development processes.',
        ],
        qualifications: [
            'Proven experience as a Machine Learning Engineer or Data Scientist.',
            'Strong knowledge of Python, TensorFlow, PyTorch, or similar frameworks.',
            'Experience with data preprocessing, feature engineering, and model evaluation.',
            'Understanding of cloud platforms (AWS, Azure, or GCP) for ML deployment.',
            'Excellent problem-solving skills and a passion for AI innovation.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'AI Solutions Architect',
        content: 'Design and implement end-to-end AI solutions, integrating advanced machine learning models with scalable enterprise systems.',
        details: {
            location: 'VisionTech Solutions, Innovation Hub',
            timing: 'Full Time',
            hours: 'Flexible Business Hours',
            experience: 'Minimum 5 Years in AI Solutions',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$110K - $150K',
            deadline: 'Apply Now - Open Until Filled',
            number: '456-789-0123',
        },
        overviews: [
            'VisionTech Solutions is looking for an experienced AI Solutions Architect to lead the design and deployment of cutting-edge AI systems. You will work closely with cross-functional teams to translate business requirements into technical AI solutions, ensuring scalability, performance, and security across the organization.',
        ],
        responsibilities: [
            'Architect and implement AI/ML solutions that meet business and technical requirements.',
            'Collaborate with stakeholders to define AI project scope and design roadmaps.',
            'Lead technical teams in the deployment of machine learning models into production.',
            'Integrate AI solutions with existing enterprise systems and data pipelines.',
            'Ensure AI systems are scalable, secure, and optimized for performance.',
        ],
        qualifications: [
            'Proven experience in AI solution architecture or enterprise-level system design.',
            'Strong knowledge of machine learning frameworks and cloud AI services (AWS, Azure, GCP).',
            'Experience integrating AI models into complex enterprise environments.',
            'Excellent communication skills for collaborating with both technical and business teams.',
            'Strong leadership and project management abilities.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'AI Product Manager',
        content: 'Drive the development and launch of AI-powered products by translating business needs into technical solutions and product strategies.',
        details: {
            location: 'NextGen AI Corp, Tech Valley',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Minimum 4 Years in Product Management',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$100K - $130K',
            deadline: 'Apply Now - Open Until Filled',
            number: '321-654-0987',
        },
        overviews: [
            'NextGen AI Corp is seeking an AI Product Manager to lead the product lifecycle of AI-powered solutions. You will work closely with engineers, data scientists, and business stakeholders to deliver innovative products that solve real-world problems. This is a critical role driving the vision and success of our AI product line.',
        ],
        responsibilities: [
            'Define product vision, strategy, and roadmap for AI-based solutions.',
            'Collaborate with cross-functional teams to ensure timely and successful product delivery.',
            'Gather and prioritize customer requirements to shape product features.',
            'Monitor product performance and iterate based on feedback and data insights.',
            'Stay current with AI technology trends and incorporate them into product planning.',
        ],
        qualifications: [
            'Proven experience as a Product Manager, preferably in AI, SaaS, or tech industries.',
            'Strong understanding of AI technologies and machine learning concepts.',
            'Excellent communication and leadership skills for cross-team collaboration.',
            'Experience managing full product lifecycles from concept to launch.',
            'Proficiency in agile methodologies and product management tools.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'AI Research Scientist',
        content: 'Conduct advanced research in artificial intelligence and machine learning to develop innovative models and algorithms for real-world applications.',
        details: {
            location: 'DeepMind Technologies, Research Park',
            timing: 'Full Time',
            hours: 'Flexible Research Hours',
            experience: 'Minimum 3 Years in AI Research',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$120K - $160K',
            deadline: 'Apply Now - Open Until Filled',
            number: '654-321-9870',
        },
        overviews: [
            'DeepMind Technologies is hiring AI Research Scientists to advance the field of artificial intelligence through cutting-edge research. You will explore novel algorithms, publish in top-tier journals, and contribute to the development of next-generation AI solutions used across industries.',
        ],
        responsibilities: [
            'Conduct original research in artificial intelligence, deep learning, and machine learning.',
            'Publish research papers and present findings at industry-leading conferences.',
            'Collaborate with engineering teams to implement research into scalable products.',
            'Stay up-to-date with the latest AI advancements and emerging technologies.',
            'Mentor junior researchers and contribute to building a world-class AI team.',
        ],
        qualifications: [
            'Ph.D. or Master’s degree in Computer Science, Artificial Intelligence, or related fields.',
            'Strong background in machine learning theory, algorithms, and model development.',
            'Proven track record of published research in AI and related fields.',
            'Experience with Python, TensorFlow, PyTorch, and data processing tools.',
            'Excellent problem-solving skills and intellectual curiosity.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'AI Software Engineer',
        content: 'Design, develop, and deploy AI-powered software applications and services, integrating machine learning models into scalable systems.',
        details: {
            location: 'NeuralWorks Inc., Tech District',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Minimum 3 Years in Software Development',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$95K - $130K',
            deadline: 'Apply Now - Open Until Filled',
            number: '789-012-3456',
        },
        overviews: [
            'NeuralWorks Inc. is looking for an AI Software Engineer to develop production-ready AI applications. You will work on integrating machine learning models into software systems, building APIs, and ensuring scalable and reliable AI solutions across our product suite.',
        ],
        responsibilities: [
            'Develop software solutions that integrate machine learning models into production environments.',
            'Build and maintain scalable APIs and microservices for AI-driven features.',
            'Collaborate with data scientists to deploy and optimize machine learning algorithms.',
            'Write clean, maintainable, and testable code using best software engineering practices.',
            'Troubleshoot and resolve technical issues in AI applications.',
        ],
        qualifications: [
            'Bachelor’s or Master’s degree in Computer Science or a related field.',
            'Strong experience in Python, Java, or C++ with a focus on backend development.',
            'Hands-on experience with machine learning frameworks such as TensorFlow or PyTorch.',
            'Familiarity with cloud platforms (AWS, Azure, GCP) for AI deployments.',
            'Solid understanding of software architecture and RESTful API design.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'AI UX/UI Designer',
        content: 'Design intuitive and user-friendly interfaces for AI-powered products, ensuring seamless interaction between users and intelligent systems.',
        details: {
            location: 'CreativeAI Studios, Design Hub',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Minimum 3 Years in UX/UI Design',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$80K - $110K',
            deadline: 'Apply Now - Open Until Filled',
            number: '210-345-6789',
        },
        overviews: [
            'CreativeAI Studios is seeking a talented AI UX/UI Designer to craft engaging user experiences for our AI-driven platforms. You will work closely with product managers and engineers to design interfaces that make complex AI solutions accessible and easy to use for a wide range of users.',
        ],
        responsibilities: [
            'Design wireframes, prototypes, and final UI for AI-powered applications.',
            'Create intuitive user flows that simplify interaction with complex AI features.',
            'Collaborate with cross-functional teams to align design with product goals.',
            'Conduct user research and usability testing to refine designs.',
            'Ensure consistency in UI design across all AI product lines.',
        ],
        qualifications: [
            'Bachelor’s degree in Design, Human-Computer Interaction, or a related field.',
            'Proven experience designing UX/UI for tech products, preferably AI or SaaS.',
            'Strong portfolio showcasing user-centric design projects.',
            'Proficiency in design tools like Figma, Sketch, or Adobe XD.',
            'Understanding of designing for AI-driven user experiences and micro-interactions.',
        ],
    }

];


const benefits = [
    {
        id: 1,
        title: "Personal Development",
        description: "At [Your Startup Name], we believe in empowering individuals to grow both personally and professionally as they contribute to shaping the future of AI technology.",
        icon: <FaTrophy />, // Personal Development Icon
    },
    {
        id: 2,
        title: "Continuous Learning",
        description: "Take part in our dynamic training programs and workshops designed to enhance your AI and tech skills, preparing you for new challenges and innovations.",
        icon: <FaChalkboardTeacher />, // Training Programs Icon
    },
    {
        id: 3,
        title: "Compensation",
        description: "We offer competitive salaries, comprehensive benefits, and performance-based rewards for your hard work and dedication to the company’s mission.",
        icon: <FaWallet />, // Compensation Icon
    },
    {
        id: 4,
        title: "Work-Life Balance",
        description: "Enjoy the flexibility of remote work and adjustable schedules, giving you the ability to maintain a healthy balance while contributing to groundbreaking projects.",
        icon: <FaCalendarAlt />, // Work-Life Balance Icon
    },
    {
        id: 5,
        title: "Innovative Teamwork",
        description: "Collaborate with talented professionals in a creative, open-minded environment, where diverse ideas shape the future of AI and technology.",
        icon: <FaUsers />, // Innovative Teamwork Icon
    },
    {
        id: 6,
        title: "Meaningful Impact",
        description: "Make a significant difference by contributing to the AI-driven solutions that transform industries and improve lives, all while working with a purpose-driven team.",
        icon: <FaLightbulb />, // Meaningful Impact Icon
    },
];


export { positions, benefits, careerIntro };